<template>
  <b-container class="pack-go-container">
    <transition name="enable-scanner">
      <div
        class="picking-list__barcode"
        v-if="useScanner"
        :class="{ 'picking-list__barcode--active': isScanning }"
        :style="{
          transform: `translateX(${x - 72}px) translateY(${y -
            22}px) rotate(-8deg)`,
        }"
      ></div>
    </transition>
    <div class="pack-go-tabs" v-if="step === 1">
      <button
        class="pack-go-tabs__button"
        :class="{ 'pack-go-tabs__button--active': isScanMode }"
        @click="isScanMode = true"
      >
        {{ $t("Scanner") }}
      </button>
      <button
        class="pack-go-tabs__button"
        :class="{ 'pack-go-tabs__button--active': !isScanMode }"
        @click="isScanMode = false"
      >
        {{ $t("Automatic") }}
      </button>
    </div>
    <div
      class="pack-go__cards-wrap pack-go__column"
      v-if="step === 1 && isScanMode"
      @mouseenter="useScanner = true"
      @mouseleave="useScanner = false"
      @mouseup="isScanning = false"
    >
      <div class="picking-list-1"></div>
      <div class="upper-picking-list"></div>
      <div
        class="upper-picking-list-1"
        @mouseleave="setHighlightedOrder(null)"
        @mousedown="isScanning = true"
        @mouseup="isScanning = false"
      >
        <div
          class="picking-list-hotspot"
          v-for="(order, index) in orders"
          :key="order.number"
          @mouseenter="setHighlightedOrder(index)"
          :style="{
            background:
              highlightedOrder === index
                ? 'transparent'
                : 'rgba(255,255,255,0.8)',
          }"
          @click="goToStep(2, index)"
        ></div>
      </div>
    </div>
    <div
      class="pack-go__cards-wrap"
      v-if="(step === 1 && !isScanMode) || (step === 2 && isScanMode)"
    >
      <div class="pack-go__order-processing-cards">
        <div class="pack-go__card">
          <div class="pack-go__button-bar" v-if="!isScanMode">
            <button
              class="button"
              @click="
                activeOrderIndex > 0
                  ? activeOrderIndex--
                  : (activeOrderIndex = 0)
              "
            >
              {{ $t("Previous") }}
            </button>
            <span class="text-muted">{{ packGoProgress }}</span>
            <button class="button" @click="goToNextOrder()">
              {{ $t("Next") }}
            </button>
          </div>
          <div class="pack-go__body">
            <div class="order-row">
              <div class="order-list-column">
                <div class="order-list-title">{{ $t("Order number") }}</div>
              </div>
              <div class="order-list-column">
                <div class="order-list-text">
                  {{ currentOrder.customer.number }}
                </div>
              </div>
            </div>
            <!-- <div class="order-row">
					<div class="order-list-column">
						<div class="order-list-title">
						{{$t('Status')}}
						</div>
					</div>
					<div class="order-list-column">
						<div class="order-list-text">
						{{$t('Ready to process')}}
						</div>
					</div>
            </div>-->
            <div class="order-row-second">
              <div class="order-list-column">
                <div class="order-list-title">{{ $t("Customer") }}</div>
              </div>
              <div class="order-list-column">
                <div class="order-list-text">
                  {{ currentOrder.customer.name }}
                </div>
              </div>
            </div>
            <div class="order-row">
              <div class="order-list-column">
                <div class="order-list-title">{{ $t("Address") }}</div>
              </div>
              <div class="order-list-column">
                <div class="order-list-text">
                  {{ currentOrder.customer.address }}
                  {{ currentOrder.customer.city }}
                </div>
                <div class="order-list-text">
                  <img
                    class="order-item__country-logo"
                    :src="
                      `https://www.flagcdn.com/w20/${currentOrder.customer.country.code}.png`
                    "
                  />
                  {{ currentOrder.customer.country.name }}
                </div>
              </div>
            </div>
            <div class="order-items-table">
              <div class="order-items-header-row">
                <div class="order-items-column">{{ $t("Item") }}</div>
                <div class="order-items-column">{{ $t("SKU") }}</div>
                <div class="order-items-column order-items-column__quantity">
                  {{ $t("Quantity") }}
                </div>
              </div>
              <div
                class="order-row"
                v-for="item in currentOrder.items"
                :key="item.sku"
              >
                <div class="order-items-column">{{ item.name }}</div>
                <div class="order-items-column">{{ item.sku }}</div>
                <div class="order-items-column order-items-column__quantity">
                  1
                </div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="pack-go__card-overlay" v-if="isLoadingOrder">
              {{ $t("Loading your order...") }}
            </div>
          </transition>
        </div>
        <div class="pack-go__card-1">
          <div class="pack-go__body">
            <div class="pack-go__input-group">
              <label class="pack-go__label">{{ $t("Send from") }}</label>
              <b-form-select
                v-model="selectedSenderAddress"
                :options="senderAddresses"
              ></b-form-select>
            </div>
            <div class="pack-go__input-group">
              <label class="pack-go__label">{{ $t("Carrier") }}</label>
              <b-form-select
                v-model="selectedCarrier"
                :options="CARRIERS"
              ></b-form-select>
            </div>
            <div class="pack-go__input-group">
              <label class="pack-go__label">{{ $t("Weight") }}</label>
              <b-form-select
                v-model="selectedWeight"
                :options="[
                  '0-10 kg',
                  '11-20 kg',
                  '21-30kg',
                  '31-40kg',
                  '41-50kg',
                  '51-100kg',
                  '100+',
                ]"
              ></b-form-select>
            </div>
          </div>
          <div class="pack-go-action-button-row">
            <button class="pack-go__process-button" @click="processOrder">
              {{
                isLoadingLabel ? $t("Creating your label...") : $t("Process")
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="pack-go__cards-wrap pack-go__column" v-if="step === 3">
      <div
        class="pack-go__packing-slip"
        :style="{ backgroundImage: `url(${publicPath}packing-slip.jpg)` }"
      ></div>
      <div class="pack-go__shipping-label">
        <ShippingLabel
          :name="orders[activeOrderIndex || 0].customer.name"
          :carrier="orders[activeOrderIndex || 0].carrier"
          :country="
            orders[activeOrderIndex || 0].customer.country
              ? orders[activeOrderIndex || 0].customer.country.name
              : orders[activeOrderIndex || 0].country.name
          "
        />
      </div>
    </div>
    <transition name="fade">
      <b-button
        class="incoming-orders__button incoming-orders__reset-button"
        @click="replay"
        v-if="step === 3 && showReplayButton"
      >
        <font-awesome-icon icon="sync" />
        {{ $t("Replay this demo") }}
      </b-button>
    </transition>
  </b-container>
</template>

<script>
require("chance");
import { BContainer, BFormSelect, BButton } from "bootstrap-vue";
import { COUNTRIES } from "@/constants/countries.js";
import ShippingLabel from "@/components/Shipping/ShippingLabel.vue";
import { getCurrentLanguage } from "@/lang/i18n.js";

import { CARRIERS } from "@/constants/carriers.js";

export default {
  name: "PackGo",
  data() {
    return {
      isScanMode: true,
      CARRIERS: CARRIERS[getCurrentLanguage()],
      step: 1,
      isLoadingOrder: false,
      isLoadingLabel: false,
      isShowLabels: false,
      orders: [],
      isScanning: false,
      useScanner: false,
      highlightedOrder: null,
      activeOrderIndex: null,
      showOrderProcessor: false,
      x: null,
      y: null,
      selectedSenderAddress: this.$t("ship address 1"),
      senderAddresses: [
        { value: this.$t("ship address 1"), text: this.$t("ship address 1") },
        { value: this.$t("ship address 2"), text: this.$t("ship address 2") },
        { value: this.$t("ship address 3"), text: this.$t("ship address 3") },
      ],
      selectedCarrier: "UPS",
      selectedWeight: "0-10 kg",
      showReplayButton: false,
      publicPath: process.env.BASE_URL,
    };
  },
  components: {
    ShippingLabel,
    BContainer,
    BFormSelect,

    BButton,
  },
  computed: {
    currentOrder() {
      return this.orders[this.activeOrderIndex];
    },
    packGoProgress() {
      return `${this.activeOrderIndex + 1} ${this.$t("of")} ${
        this.orders.length
      }`;
    },
  },
  created() {
    document.addEventListener("mousemove", this.handleMouseMove);
  },
  destroyed() {
    document.removeEventListener("mousemove", this.handleMouseMove);
  },
  mounted() {
    for (let index = 0; index < 6; index++) {
      let itemLength = chance.integer({ min: 1, max: 2 });
      let items = [];

      for (let index = 0; index < itemLength; index++) {
        items.push(this.generateRandomOrder());
      }

      this.orders.push({
        items,
        customer: this.generateRandomClient(),
        carrier: chance.pickset(this.CARRIERS)[0],
      });
    }

    this.activeOrderIndex = 0;
  },
  methods: {
    goToNextOrder() {
      if (this.activeOrderIndex < this.orders.length - 1) {
        this.activeOrderIndex = this.activeOrderIndex + 1;
      } else {
        this.activeOrderIndex = 0;
      }
    },
    setHighlightedOrder(index) {
      this.highlightedOrder = index;
    },
    handleMouseMove() {
      this.x = event.clientX;
      this.y = event.clientY;
    },
    generateRandomClient() {
      return {
        name: chance.name(),
        address: chance.address(),
        postCode: chance.postcode(),
        city: chance.city(),
        country: chance.pickset(COUNTRIES)[0],
        number: chance.string({
          length: 8,
          casing: "upper",
          alpha: true,
          numeric: true,
        }),
      };
    },
    generateRandomOrder() {
      return {
        status: "Ready to process",
        subStatus: "Label not yet printed",
        name: chance.pickset([
          "Nike Sports T-Shirt",
          "Nike Air Max",
          "Sway Wallpaper 20x50",
          "Photo Album XS",
          "Sony WRN-900 Headphones",
        ])[0],
        sku: chance.string({
          length: 8,
          casing: "upper",
          alpha: true,
          numeric: true,
        }),
      };
    },
    goToStep(index, orderIndex) {
      if (index === 2) {
        //From picking list to process overview
        this.useScanner = false;
        this.isLoadingOrder = true;
        this.showOrderProcessor = true;
        this.activeOrderIndex = orderIndex;
        this.setHighlightedOrder(null);
        setTimeout(() => {
          this.isLoadingOrder = false;
        }, 1000);
      }
      this.step = index;
    },
    processOrder() {
      this.isLoadingLabel = true;

      setTimeout(() => {
        this.showOrderProcessor = false;
        this.step = 3;
        this.isLoadingLabel = false;
        this.orders[this.activeOrderIndex].carrier = this.CARRIERS.find(
          (carrier) => carrier.value === this.selectedCarrier
        );
      }, 1000);

      setTimeout(() => {
        this.showReplayButton = true;
      }, 4000);
    },
    replay() {
      this.setHighlightedOrder(null);
      this.goToStep(1, 0);
    },
  },
};
</script>

<style lang="postcss" scoped>
.pack-go-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.pack-go__cards-wrap {
  width: 100%;
  min-height: 600px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}

.pack-go__order-processing-cards {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.button {
  width: 98px;
  margin: 0px 0px 0px 0px;
  padding: 6px 5px 6px 5px;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  font-size: 15px;
  color: rgb(59, 59, 59);
  outline: none !important;
  background: white;
  transition: background 0.2s, transform 0.2s;
}

.pack-go-tabs {
  display: flex;
  background: #f8f8f8;
  border-radius: 5px;
  margin-bottom: 45px;
  font-size: 15px;
  width: 250px;
  box-shadow: 0px 0px 4px 1px inset rgba(0, 0, 0, 0.05),
    0px 0px 0px 1px rgba(0, 0, 0, 0.1);
}

.pack-go-tabs__button {
  border-radius: 4px;
  flex-grow: 1;
  user-select: none;
  display: block;
  border: none;
  margin: 4px;
  transition: background 0.5s;
  background: transparent;
  &:focus {
    outline: none;
  }
}

.pack-go-tabs__button--active {
  background: white;
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.1);
}

.button:active {
  transform: scale(1.08);
}

.button:hover {
  background: rgba(0, 0, 0, 0.05);
}

.order-items-header-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 0px 0px 0px 0px;
  font-size: 18.5px;
  text-align: center;
  color: rgb(134, 134, 134);
}

.order-items-table {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 20px 0px 0px 0px;
}

.order-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 0px 0px 0px 0px;
}

.order-row-second {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 15px 0px 0px 0px;
}

.pack-go-action-button-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 41px;
  margin: 0px 0px 0px 0px;
}

.pack-go__body {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 0px 0px 0px 0px;
  opacity: 1;
  font-size: 11px;
}

.pack-go__input-group {
  width: 100%;
  margin-bottom: 10px;
}

.pack-go__label {
  font-family: "BeatriceMedium";
  font-size: 12px;
  margin-top: 0;
}

.pack-go__select {
  height: 40px;
  border-radius: 5px;
  background: none;
  width: 100%;
  border: 1px solid #dedede;
  font-size: 14px;
}

.pack-go__button-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0px 0px 25px 0px;
}

.pack-go__card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  min-width: 675px;
  padding: 25px 25px 25px 25px;
  background: white;
  border: 1px solid rgb(231, 231, 231);
  border-radius: 10px;
  box-shadow: 0px 0px 13px 0px rgba(21, 38, 65, 0.08);
  overflow: hidden;
}

.pack-go__card-1 {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow: 1;
  margin: 0px 0px 0px 25px;
  padding: 25px 25px 25px 25px;
  background: white;
  border: 1px solid rgb(231, 231, 231);
  border-radius: 10px;
  box-shadow: 0px 0px 13px 0px rgba(21, 38, 65, 0.08);
  overflow: hidden;
}

.pack-go__card-body {
  bottom: 0px;
  left: 0px;
  right: 0px;
  top: 0px;
  display: flex;
  width: 100%;
  min-height: 45px;
  background: white;
  border-radius: 0px;
  opacity: 1;
  font-size: 53px;
}

.pack-go__card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0px 0px 0px 0px;
  padding: 10px 0px 0px 0px;
  background: white;
  opacity: 1;
}

.picking-list-hotspot {
  display: flex;
  width: 100%;
  min-height: 66px;
  margin: 0px 0px 0px 0px;
  cursor: pointer;
  transition: background 0.8s;
}

.picking-list__barcode {
  position: fixed;
  z-index: auto;
  display: flex;
  width: 90px;
  animation: barcode-animation;
  animation-duration: 100ms;
  animation-iteration-count: infinite;
  pointer-events: none;
  top: 20px;
  left: 25px;
  height: 2px;
  background: rgb(255, 238, 238);
  border-radius: 3px;
  z-index: 1000;
  box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.33),
    0px 0px 3px 1px rgba(255, 115, 115, 0.84),
    0px 0px 0px 0px rgba(255, 25, 25, 0.94),
    0px 0px 26px 26px rgba(255, 4, 4, 0.23);
}

@keyframes barcode-animation {
  0% {
    box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.23),
      0px 0px 3px 1px rgba(255, 115, 115, 0.84),
      0px 0px 26px 26px rgba(255, 4, 4, 0.13);
  }
  100% {
    box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.33),
      0px 0px 3px 1px rgba(255, 115, 115, 0.84),
      0px 0px 26px 26px rgba(255, 4, 4, 0.23);
  }
}

.picking-list__barcode--active {
  animation: barcode-active-animation;
  animation-duration: 100ms;
  animation-iteration-count: infinite;
}

@keyframes barcode-active-animation {
  0% {
    box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.33), 0px 0px 3px 1px #ff739b,
      0px 3px 26px 26px rgba(255, 4, 4, 0.23),
      0px 3px 71px 70px rgba(228, 59, 59, 0);
  }
  100% {
    box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.33), 0px 0px 3px 1px #ff739b,
      0px 3px 26px 26px rgba(255, 4, 4, 0.23),
      0px 3px 71px 70px rgba(228, 59, 59, 0.45);
  }
}

.rectangle-2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 285px;
  min-height: 324px;
  margin: 28px 0px 0px 42px;
  background: linear-gradient(rgb(230, 230, 230), rgb(230, 230, 230));
  font-size: 16.5px;
  text-align: center;
}

.upper-picking-list,
.upper-picking-list-1,
.picking-list-1 {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 400px;
  height: 600px;
  margin: 12px 0px 0px 12px;
  padding: 99px 20px 104px 20px;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(-4deg);
  background: url(https://firebasestorage.googleapis.com/v0/b/handoff-59cbc.appspot.com/o/projects%2Fd4r8PKmiUviqVWKUTeuy%2Fimages%2FPicking%20List.svg?alt=media&token=d17daf96-ad77-4f75-a1a3-aefeeaec632d)
    50% 50% / contain no-repeat;
  border-radius: 7px;
  box-shadow: 3px 0px 9px 2px rgba(21, 38, 65, 0.07);
  background-color: white;
}

.upper-picking-list-1 {
  margin: 12px 0px 0px 10px;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(-8deg);
}

.picking-list-1 {
  margin: 0px 0px 0px 4px;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
}

.pack-go__packing-slip {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 400px;
  height: 600px;
  margin: 12px 0px 0px 10px;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(-4deg);
  background-color: white;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 7px;
  box-shadow: 3px 0px 9px 2px rgba(21, 38, 65, 0.07);
}

.pack-go__shipping-label {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 50px 0px 0px 200px;
  transform: rotateX(0deg) rotateY(0deg) rotateZ(8deg) scale(0.65);
  background-color: white;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 7px;
}

.order-item-column {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 50px;
  margin: 0px 0px 0px 0px;
  padding: 10px 10px 10px 10px;
  font-size: 17.5px;
}

.order-items-header-column {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0px 0px 0px 0px;
  font-size: 13.5px;
  width: 33.3%;
}

.order-view-heading {
  min-height: null;
  margin: 20px 0px 0px 0px;
  font-weight: 600;
  font-size: 19px;
  color: rgb(23, 61, 105);
  text-align: center;
}

.order-items-column {
  display: flex;
  flex-grow: 1;
  font-size: 15px;
  width: 33.3%;
  padding: 5px 0px;
  margin: 0px 0px 0px 0px;
}

.order-items-column__quantity {
  justify-content: flex-end;
  width: 10%;
}

.order-list-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 50%;
  margin: 0px 0px 0px 0px;
  padding: 2px 0px 2px 0px;
  font-size: 15px;
}

.order-list-text {
  width: 100%;
  line-height: 1.5em;
}

.order-list-title {
  width: 144px;
  color: rgb(134, 134, 134);
}

.pack-go__process-button {
  flex: 1 0;
  min-height: 40px;
  margin: 20px 0px 0px 0px;
  padding: 6px 5px 6px 5px;
  background: rgb(29, 151, 255);
  border: 1px none black;
  border-radius: 5px;
  font-size: 15px;
  transition: transform 0.2s, background 0.2s;
  color: #ffffff;
}

.pack-go__process-button:active {
  transform: scale(1.05);
  background: rgb(24, 123, 209);
}

.pack-go__process-button:focus {
  outline: none;
}

.enable-scanner-enter-active,
.enable-scanner-leave-active {
  transition: opacity 0.5s ease, width 0.5s ease;
}
.enable-scanner-enter,
.enable-scanner-leave-to {
  opacity: 0;
  width: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
